/* esm.sh - date-fns@4.1.0/_lib/normalizeDates */
import{constructFrom as e}from"../constructFrom.mjs";function m(n,...o){let r=e.bind(null,n||o.find(t=>typeof t=="object"));return o.map(r)}export{m as normalizeDates};
//# sourceMappingURL=normalizeDates.mjs.map